<template>
  <div
    class="F360-Bagde hidden-xs-and-down"
    :class="typeColor"
    :style="{
      borderRadius: radius,
      width: size,
      height: size
    }"
  >
    <span :style="{ fontSize: textSize }">{{ text }}</span>
  </div>
</template>

<script setup lang="ts">
type IProps = {
  text: string;
  shape?: "circle" | "square";
  textSize?: string;
  typeColor?: TF360BagdeTypeColor;
}
import { computed } from 'vue'
export type TF360BagdeTypeColor =
  | "primary"
  | "secondary"
  | "success"
  | "danger"
  | "warning"
  | "info"
  | "light"
  | "dark";
const props = withDefaults(defineProps<IProps>(), {
  shape: "square",
  textSize: "8px"
});
const size = computed(() => {
  return props.shape === "circle" ? "12px" : "14px";
});
const radius = computed(() => {
  return props.shape === "circle" ? "50%" : "4px";
});
</script>

<style lang="scss" scoped>
@use "sass:map" as *;
@use "@/ui/styles/theme/f360-theme.scss" as *;

.F360-Bagde {
  font-family: "Plus Jakarta Sans", sans-serif;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 4px 4px;
  width: 15px;
  height: 16px;
  color: _map.get($neutro, 900);
  font-size: 10px;

  &.primary {
    background-color: _map.get($azulPrincipal, 300);
  }

  &.secondary {
    background-color: _map.get($neutro, 900);
  }

  &.success {
    background-color: _map.get($verde, 300);
  }

  &.danger {
    background-color: _map.get($vermelho, 300);
  }

  &.warning {
    background-color: _map.get($amarelo, 300);
  }

  &.info {
    background-color: _map.get($azulPrincipal, 300);
  }

  &.light {
    background-color: _map.get($neutro, 100);
  }

  &.dark {
    background-color: _map.get($neutro, 300);
  }
}
</style>
